import { useState } from 'react';
// A visually empty editor can hold `<p></p>`, `<p><br></p>` or whitespace-only
// markup, so parse the markup and inspect the text content (keeping `<img>` as
// meaningful content) instead of comparing HTML strings.
export const isEditorEmpty = (html) => {
    const el = document.createElement('div');
    el.innerHTML = html;
    if (el.querySelector('img') != null) {
        return false;
    }
    // trim() also strips non-breaking spaces (U+00A0), so a body of only
    // `&nbsp;` counts as empty.
    return (el.textContent ?? '').trim() === '';
};
export const useEditorState = (defaultContent) => {
    const [htmlContent, setHtmlContent] = useState(defaultContent ?? '<p></p>');
    const [content, newContent] = useState(defaultContent ?? '<p></p>');
    return {
        html: htmlContent,
        onChange: setHtmlContent,
        editorContent: content,
        overwriteEditorContent: (content) => {
            newContent('');
            newContent(content);
        },
    };
};
//# sourceMappingURL=hooks.js.map